/* global google */
/* eslint react/no-did-mount-set-state: 0 */

import {Component} from 'react';
import PropTypes from 'prop-types';
import markerwithlabel from 'markerwithlabel';

export class Marker extends Component {
    static iconPlaceholder = 'data:image/svg+xml,%3Csvg%20width%3D%221px%22%20height%3D%221px%22%20viewBox%3D%220%200%201%201%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Cg%20id%3D%22marker%22%3E%3Crect%20id%3D%22Rectangle%22%20x%3D%223%22%20y%3D%2231%22%20width%3D%221%22%20height%3D%221%22%20rx%3D%220.5%22%3E%3C%2Frect%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E';

    static propTypes = {
        map: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
        className: PropTypes.string,
        position: PropTypes.shape({
            lat: PropTypes.number,
            lng: PropTypes.number
        }),
        content: PropTypes.string,
        zIndex: PropTypes.number,
        showZone: PropTypes.bool,
        zoneOptions: PropTypes.shape({
            strokeColor: PropTypes.string,
            strokeOpacity: PropTypes.number,
            strokeWeight: PropTypes.number,
            fillColor: PropTypes.string,
            fillOpacity: PropTypes.number,
            visible: PropTypes.bool,
            radius: PropTypes.number
        }),
        clickable: PropTypes.bool
    };

    constructor() {
        super();

        this.isActive = false;

        this.state = {
            marker: null,
            circle: null
        };
    }

    componentDidMount() {
        const MarkerWithLabel = markerwithlabel(google.maps);

        const {
            map,
            className: labelClass,
            showZone,
            zoneOptions,
            position,
            content: labelContent,
            clickable = true
        } = this.props;

        const marker = new MarkerWithLabel({
            position,
            map,
            labelContent,
            labelClass,
            icon: Marker.iconPlaceholder,
            clickable
        });

        if (clickable) {
            google.maps.event.addListener(marker, 'click', this.handleClick);
        }

        this.setState({marker});

        if (showZone && clickable) {
            const circle = new google.maps.Circle({...zoneOptions, map});
            circle.bindTo('center', marker, 'position');
            this.setState({circle});
            google.maps.event.addListener(marker, 'mouseover', () => {
                this.showRange();
            });
            google.maps.event.addListener(marker, 'mouseout', () => {
                if (!this.isActive) {
                    this.hideRange();
                }
            });
        }
    }

    componentDidUpdate() {
        const {marker} = this.state;
        const {className: labelClass, zIndex} = this.props;
        marker.setZIndex(zIndex);
        marker.set('labelClass', labelClass);
    }

    componentWillUnmount = () => this.state.marker.setMap(null);

    handleClick = () => {
        const {circle} = this.state;
        const {onClick} = this.props;

        this.isActive = !this.isActive;

        if (onClick) {
            onClick(this);
        }

        if (!circle) {
            return;
        }

        const isVisible = circle.getVisible();

        if (isVisible && this.isActive) {
            return;
        }

        circle.setVisible(!circle.getVisible());
    };

    reset = () => {
        this.isActive = false;
        this.hideRange();
    };

    get marker() {
        return this.state.marker;
    }

    get id() {
        return this.props.id;
    }

    showRange = () => this.state.circle && this.state.circle.setVisible(true);

    hideRange = () => this.state.circle && this.state.circle.setVisible(false);

    render = () => null;
}

export default Marker;
